import { render, staticRenderFns } from "./WijkInfo.vue?vue&type=template&id=b6eb9b24&"
import script from "./WijkInfo.vue?vue&type=script&lang=js&"
export * from "./WijkInfo.vue?vue&type=script&lang=js&"
import style0 from "./WijkInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports